import type { EmblaCarouselType } from "embla-carousel";

/**
 * サムネイル要素をクリックすると、メインカルーセルが対応するスライドに移動する機能
 * @param emblaApiMain
 * @param emblaApiThumb
 * @returns
 */
export const addThumbBtnsClickHandlers = (
  emblaApiMain: EmblaCarouselType,
  emblaApiThumb: EmblaCarouselType
): (() => void) => {
  const slidesThumbs = emblaApiThumb.slideNodes();

  const scrollToIndex = slidesThumbs.map(
    (_, index) => (): void => emblaApiMain.scrollTo(index)
  );

  slidesThumbs.forEach((slideNode, index) => {
    slideNode.addEventListener('click', scrollToIndex[index], false);
  });

  return (): void => {
    slidesThumbs.forEach((slideNode, index) => {
      slideNode.removeEventListener('click', scrollToIndex[index], false);
    });
  };
};

/**
 * メインカルーセルでスライドが変わったとき、対応するサムネイルにクラスを付与
 * メインカルーセルの選択に合わせてサムネイルカルーセルも自動的にスクロール
 * @param emblaApiMain
 * @param emblaApiThumb
 * @returns
 */
export const addToggleThumbBtnsActive = (
  emblaApiMain: EmblaCarouselType,
  emblaApiThumb: EmblaCarouselType
): (() => void) => {
  const selectedClassName = 'is-snapped';
  const slidesThumbs = emblaApiThumb.slideNodes();

  const toggleThumbBtnsState = (): void => {
    emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
    const previous = emblaApiMain.previousScrollSnap();
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs[previous].classList.remove(selectedClassName);
    slidesThumbs[selected].classList.add(selectedClassName);
  }

  emblaApiMain.on('select', toggleThumbBtnsState);
  emblaApiThumb.on('init', toggleThumbBtnsState);

  return (): void => {
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs[selected].classList.remove(selectedClassName);
  };
};